export default __webpack_public_path__ + "static/media/OFERTAS RELAMPAGOS.36b0db88.png";